import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import BankConnectBanner from "./BankConnectBanner";
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { useNavigate } from "react-router-dom";
import { keyActivate } from "../../utils/a11y";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

let { lambda, appname } = window.app

// Custom dialog component – uses position:fixed + translate for bulletproof centering
// independent of whatever the CDN CSS does to .modal-dialog
const CompareDialog = React.forwardRef(({ children, className, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    className={className}
    style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '460px',
      width: '100%',
      margin: 0,
      zIndex: 1056,
    }}
  >
    {children}
  </div>
));

const views = ['DAY', 'WEEK', 'MONTH', 'YEAR'];


const data = [
  { id: 1, name: 'Park City Shop', category: 'Retail', status: 'Active', date: '2025-05-01' },
  { id: 2, name: 'Night Club Deluxe', category: 'Entertainment', status: 'Inactive', date: '2025-04-28' },
  { id: 3, name: 'Sunset Lounge', category: 'Nightlife', status: 'Active', date: '2025-05-05' },
  { id: 4, name: 'Urban Market', category: 'Retail', status: 'Inactive', date: '2025-03-22' },
];

const columns = [
  { name: 'Name', selector: row => row?.data?.name },
  { name: 'Total Reserved', selector: row => row?.data?.totalReservedCount },
  { name: 'Total Completed Reservations', selector: row => row?.data?.totalCompletedCount },
  { name: 'Repeat Visitors', selector: row => row?.data?.repeatVisitor },
  { name: 'Walk-Ins', selector: row => row?.data?.walkinPercentage },
  { name: 'Average Visit Duration', selector: row => row?.data?.averageVisitDuration },
  { name: 'Favorites', selector: row => row?.data?.favourites },
];
const countColumns = [
  // console.log("currentData", currentData),
  // console.log("compareData", compareData),
  {
    name: "Date",
    selector: row => row?.label,
    cell: row => <strong>{row?.label}</strong>,
  },
  {
    name: <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>Total <div className="total-color"></div></span>,
    selector: row => row?.data?.totalCount
  },
  {
    name: <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>Active <div className="active-color"></div></span>,
    selector: row => row?.data?.activeCount
  },
  {
    name: <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>Completed <div className="completed-color"></div></span>,
    selector: row => row?.data?.completedCount
  },
  // {
  //   name: (
  //     <>
  //       Walk-ins <div className="walk-color"></div>
  //     </>
  //   ),
  //   selector: row => row?.data?.walikinCount
  // },
  {
    name: <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>Canceled <div className="canceled-color"></div></span>,
    selector: row => row?.data?.cancelledCount
  },
  {
    name: <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>Expired <div className="expired-color"></div></span>,
    selector: row => row?.data?.expiredCount
  },
  {
    name: <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>Future <div className="future-color"></div></span>,
    selector: row => row?.data?.pendingCount
  }
];

const DashBoard = () => {
  const navigate = useNavigate();
  const [view, setView] = useState("DAY");
  const [filterType, setFilterType] = useState("Total");
  const [xAxisData, setXAxisData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [locationData, setLocationData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [dateRange, setDateRange] = useState({ fromDate: '', toDate: '' });
  const [selectedType, setSelectedType] = useState("Total");
  const [show, setShow] = useState(false)
  const [summary, setSummary] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, isRefreshed, setIsRefreshed, userData, clientInfo, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
  const useruniqueid = localStorage.getItem("clientid")
  const [selectedMode, setSelectedMode] = useState("Day");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [range1, setRange1] = useState({ fromDate: '', toDate: '' });
  const [range2, setRange2] = useState({ fromDate: '', toDate: '' });
  const [statisticsData, setStatisticsData] = useState([]);
  const [allCounts, setAllCounts] = useState([])
  const [currentData, setCurrentData] = useState([]);
  const [compareData, setCompareData] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false)
  const [sameDateError, setSameDateError] = useState('')
  const calendarRef = useRef(null);
  const [image, setImg] = useState('')
  // Snapshots of the two compared periods (fromDate/toDate/groupBy), taken at
  // compare time so the headers can show the full period, not just the start day.
  const [compareRange, setCompareRange] = useState(null);
  const [currentRange, setCurrentRange] = useState(null);

  // Formats a period the same way the backend's formatDateRangeName does, so the
  // banner / graph headers match the "Statistics for selected period" titles.
  const formatPeriodLabel = (range) => {
    if (!range?.fromDate) return '';
    const start = moment(range.fromDate);
    const end = range.toDate ? moment(range.toDate) : start;
    const fmt = (m) => m.format('MMMM D, YYYY'); // e.g. "June 1, 2026"
    const groupBy = (range.groupBy || '').toLowerCase();
    if (groupBy === 'day') return fmt(start);
    const separator = (groupBy === 'month' || groupBy === 'year') ? ' ~ ' : ' to ';
    return `${fmt(start)}${separator}${fmt(end)}`;
  };
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const paymentNotSuccess = clientInfo?.subscriptionPayment !== "PAYMENT SUCCESS";
  //   // const hasSubscriptionPrice = clientInfo?.subscriptionPrice !== "0" && clientInfo?.subscriptionPrice !== 0;

  //   if (!token || (paymentNotSuccess )) {
  //     navigate("/signin");
  //   }
  // }, [clientInfo]);



  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }



  }, [window.site]);
  const handleClickOutside = (e) => {
    if (calendarRef.current && !calendarRef.current.contains(e.target)) {
      setShowCalendar(false);
    }
  };
  useEffect(() => {
    if (showCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCalendar]);
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    // Skip if clientInfo is still empty
    if (!clientInfo?.subscriptionPayment) return;

    if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
      navigate("/signin");
    }
  }, [clientInfo, navigate]);



  // // console.log("fromDateeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", fromDate)
  // // console.log("toDateeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", toDate)
  const filteredData = useMemo(() => {
    const key = selectedType.toLowerCase(); // e.g., "total", "completed", etc.
    // console.log("key", key)
    // console.log("chartData", chartData)
    if (!Array.isArray(chartData)) return [];

    return chartData.map(item => ({

      ...item,
      [key]: selectedType === "Total" ? item.total : (item[key] > 0 ? item[key] : null),
    }));
  }, [selectedType, chartData]);
  // console.log("itemchartDatachartDatachartData", chartData)

  const data = [
    { day: 'Mon', week1: 5, week2: -4 },
    { day: 'Tue', week1: 3, week2: -6 },
    { day: 'Wed', week1: 4, week2: -2 },
    { day: 'Thu', week1: 0, week2: 0 },
    { day: 'Fri', week1: 2, week2: -3 },
    { day: 'Sat', week1: 0, week2: 0 },
    { day: 'Sun', week1: 1, week2: -1 },
  ];
  const isWeekData = currentData.length === 7;

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getWeekdayName = (dateStr) => {
    const fullDate = new Date(`${dateStr}, 2024`);
    return weekDays[fullDate.getDay()];
  };

  const getDayNumber = (dateStr) => {
    const parts = dateStr.split(" ");
    return parts[1]; // e.g., "May 01" → "01"
  };

  const mergedData = currentData.map((item, index) => {
    const r2 = compareData[index];

    let nameLabel;

    if (isWeekData) {
      nameLabel = getWeekdayName(item.name);
    } else if (/\w+\s\d{2}/.test(item.name)) {
      nameLabel = getDayNumber(item.name);
    } else {
      nameLabel = item.name;
    }

    return {
      name: nameLabel,
      completedPositive: item.completed,
      activePositive: item.active,
      canceledPositive: item.cancelled,
      expiredPositive: item.expired,
      futurePositive: item.pendingCount,
    };
  });


  // Transform the 'previous' dataset to negative for bottom display
  const transformedData = data.map((d) => ({
    ...d,
    previous: -d.previous,
  }));

  const centerYAxisPosition = 150;
  // // console.log("filterrrrrrrrrrrrrrrrrrrrrrrrrData", filteredData)
  // const StackedBarChart = ({ }) => {
  //   // // console.log("View:", view);

  //   // Set barSize based on view
  //   let barSize = 20; // Default for DAY
  //   let interval
  //   if (view === "WEEK") {
  //     barSize = 80;
  //   } else if (view === "MONTH") {
  //     barSize = 50;
  //     interval = 0
  //   } else if (view === "YEAR") {
  //     barSize = 70;
  //   }
  //   console.log("selectedType", selectedType)
  //   return (
  //     <ResponsiveContainer width="100%" height={350}>
  //       {currentData?.length > 0 && compareData?.length > 0 ?
  //         <BarChart data={mergedData}>
  //           <CartesianGrid strokeDasharray="3 3" />
  //           <XAxis dataKey="name" />
  //           <YAxis />
  //           <Tooltip />
  //           {/* <Legend /> */}

  //           {/* Completed Bars */}
  //           {(selectedType === "Total" || selectedType === "Completed") && (
  //             <>
  //               <Bar dataKey="completedPositive" stackId="a" fill="#b187f4" isAnimationActive />
  //               <Bar dataKey="completedNegative" stackId="b" fill="#b187f4" isAnimationActive />
  //             </>
  //           )}

  //           {/* Active Bars */}
  //           {(selectedType === "Total" || selectedType === "Active") && (
  //             <>
  //               <Bar dataKey="activePositive" stackId="a" fill="#ec90d0" isAnimationActive />
  //               <Bar dataKey="activeNegative" stackId="b" fill="#ec90d0" isAnimationActive />
  //             </>
  //           )}

  //           {/* Cancelled Bars */}
  //           {(selectedType === "Total" || selectedType === "Canceled") && (
  //             <>
  //               <Bar dataKey="canceledPositive" stackId="a" fill="#8bd1ff" isAnimationActive />
  //               <Bar dataKey="canceledNegative" stackId="b" fill="#8bd1ff" isAnimationActive />
  //             </>
  //           )}

  //           {/* Expired Bars */}
  //           {(selectedType === "Total" || selectedType === "Expired") && (
  //             <>
  //               <Bar dataKey="expiredPositive" stackId="a" fill="#f7d26e" isAnimationActive />
  //               <Bar dataKey="expiredNegative" stackId="b" fill="#f7d26e" isAnimationActive />
  //             </>
  //           )}
  //           {/* Future Bars */}
  //           {(selectedType === "Total" || selectedType === "Future") && (
  //             <>
  //               <Bar dataKey="futurePositive" stackId="a" fill="#320bf1ff" isAnimationActive />
  //               <Bar dataKey="futureNegative" stackId="b" fill="#320bf1ff" isAnimationActive />
  //             </>
  //           )}
  //         </BarChart> :
  //         <BarChart data={filteredData} barSize={barSize}>
  //           <CartesianGrid strokeDasharray="7 7" vertical={false} horizontal={true} />
  //           <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} interval={interval} />
  //           <YAxis />
  //           <Tooltip />

  //           {(selectedType === "Total" || selectedType === "Completed") && (
  //             <Bar dataKey="completed" stackId="a" fill="#b187f4" isAnimationActive />
  //           )}
  //           {(selectedType === "Total" || selectedType === "Active") && (
  //             <Bar dataKey="active" stackId="a" fill="#ec90d0" isAnimationActive />
  //           )}
  //           {(selectedType === "Total" || selectedType === "Canceled") && (
  //             <Bar dataKey="canceled" stackId="a" fill="#8bd1ff" isAnimationActive />
  //           )}
  //           {(selectedType === "Total" || selectedType === "Expired") && (
  //             <Bar dataKey="expired" stackId="a" fill="#f7d26e" isAnimationActive />
  //           )}
  //           {(selectedType === "Total" || selectedType === "Future") && (
  //             <Bar dataKey="future" stackId="a" fill="#320bf1ff" isAnimationActive />
  //           )}
  //         </BarChart>}





  //     </ResponsiveContainer>


  //   );
  // };

  const StackedBarChart = ({ data }) => {
    // console.log("dataaaaaaaaaaaaaaaaaaaaaaaaaaa", data)
    // console.log("View:", view);
    // console.log("filteredDatafilteredDatafilteredData", filteredData)
    let barSize = 20;
    let interval;

    if (view === "WEEK") barSize = 80;
    else if (view === "MONTH") {
      barSize = 50;
      interval = 0;
    } else if (view === "YEAR") barSize = 70;

    return (
      <ResponsiveContainer width="100%" height={350}>
        {currentData?.length > 0 && compareData?.length > 0 ?
          <BarChart data={data} barSize={barSize}>
            <CartesianGrid strokeDasharray="7 7" vertical={false} />
            <XAxis
              dataKey="name"
              angle={-45}
              textAnchor="end"
              height={70}
              interval={interval}
            />
            <YAxis />
            <Tooltip />

            {(selectedType === "Total" || selectedType === "Completed") && (
              <Bar dataKey="completed" stackId="a" fill="#b187f4" />
            )}
            {(selectedType === "Total" || selectedType === "Active") && (
              <Bar dataKey="active" stackId="a" fill="#ec90d0" />
            )}
            {(selectedType === "Total" || selectedType === "Canceled") && (
              <Bar dataKey="canceled" stackId="a" fill="#8bd1ff" />
            )}
            {(selectedType === "Total" || selectedType === "Expired") && (
              <Bar dataKey="expired" stackId="a" fill="#f7d26e" />
            )}
            {(selectedType === "Total" || selectedType === "Future") && (
              <Bar dataKey="future" stackId="a" fill="#320bf1ff" />
            )}
          </BarChart> :
          <BarChart data={filteredData} barSize={barSize}>
            <CartesianGrid strokeDasharray="7 7" vertical={false} />
            <XAxis
              dataKey="name"
              angle={-45}
              textAnchor="end"
              height={70}
              interval={interval}
            />
            <YAxis />
            <Tooltip />

            {(selectedType === "Total" || selectedType === "Completed") && (
              <Bar dataKey="completed" stackId="a" fill="#b187f4" />
            )}
            {(selectedType === "Total" || selectedType === "Active") && (
              <Bar dataKey="active" stackId="a" fill="#ec90d0" />
            )}
            {(selectedType === "Total" || selectedType === "Canceled") && (
              <Bar dataKey="canceled" stackId="a" fill="#8bd1ff" />
            )}
            {(selectedType === "Total" || selectedType === "Expired") && (
              <Bar dataKey="expired" stackId="a" fill="#f7d26e" />
            )}
            {(selectedType === "Total" || selectedType === "Future") && (
              <Bar dataKey="future" stackId="a" fill="#320bf1ff" />
            )}
          </BarChart>}
      </ResponsiveContainer>
    );
  };

  const getCurrentMonday = () => {
    const today = new Date();
    const day = today.getDay();
    const diff = day === 0 ? -6 : 1 - day; // Adjust for Sunday (0)
    return new Date(today.setDate(today.getDate() + diff));
  };


  // // console.log("rangeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee1", range1)
  // // console.log("rangeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee2", range2)


  // Update default dates based on selected mode
  // useEffect(() => {
  //   const now = new Date();

  //   if (selectedMode === "Day") {
  //     setFromDate(now);
  //     setToDate(now);
  //   } else if (selectedMode === "Week") {
  //     const monday = getCurrentMonday();
  //     setFromDate(monday);
  //     setToDate(monday);
  //   } else if (selectedMode === "Month") {
  //     const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  //     setFromDate(firstDay);
  //     setToDate(firstDay);
  //   } else if (selectedMode === "Year") {
  //     const janFirst = new Date(now.getFullYear(), 0, 1);
  //     setFromDate(janFirst);
  //     setToDate(janFirst);
  //   }
  // }, [selectedMode]);

  useEffect(() => {
    const now = new Date();

    if (selectedMode === "Day") {
      // Today → Today
      setFromDate(now);
      setToDate(now);

    } else if (selectedMode === "Week") {
      // Monday → Sunday
      const day = now.getDay(); // 0 (Sun) - 6 (Sat)
      const diffToMonday = day === 0 ? -6 : 1 - day;

      const monday = new Date(now);
      monday.setDate(now.getDate() + diffToMonday);

      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      setFromDate(monday);
      setToDate(sunday);

    } else if (selectedMode === "Month") {
      // 1st → Last day of month
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      setFromDate(firstDay);
      setToDate(lastDay);

    } else if (selectedMode === "Year") {
      // Jan 1 → Dec 31
      const janFirst = new Date(now.getFullYear(), 0, 1);
      const decLast = new Date(now.getFullYear(), 11, 31);

      setFromDate(janFirst);
      setToDate(decLast);
    }
  }, [selectedMode]);


  // Filter only Mondays for Week mode
  const isMonday = (date) => {
    return date.getDay() === 1;
  };

  // DatePicker props based on selected mode
  const getPickerProps = () => {
    if (selectedMode === "Day") {
      return {
        dateFormat: "dd/MM/yyyy",
      };
    } else if (selectedMode === "Week") {
      return {
        filterDate: isMonday,
        placeholderText: "Select Monday",
        dateFormat: "dd/MM/yyyy",
      };
    } else if (selectedMode === "Month") {
      return {
        showMonthYearPicker: true,
        dateFormat: "MMMM yyyy", // ⬅️ Will show "May 2025" instead of "05/2025"
      };
    } else if (selectedMode === "Year") {
      return {
        showYearPicker: true,
        dateFormat: "yyyy",
      };
    }
  };



  const getPastCurrentFuturePayloads = ({ fromDate, toDate, groupBy }) => {
    const inputFrom = new Date(fromDate);
    const inputTo = new Date(toDate);

    const formatDate = (date, isStart = true) => {
      const d = new Date(date);
      d.setHours(isStart ? 0 : 23, isStart ? 0 : 59, isStart ? 0 : 59, 0);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      const sec = String(d.getSeconds()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}T${hh}:${min}:${sec}`;
    };

    let lastBeforeFrom, lastBeforeTo, beforeFrom, beforeTo, currentFrom, currentTo;

    if (groupBy === 'day') {
      const current = new Date(fromDate);
      const before = new Date(current);
      before.setDate(current.getDate() - 1);
      const lastBefore = new Date(current);
      lastBefore.setDate(current.getDate() - 2);

      lastBeforeFrom = formatDate(lastBefore, true);
      lastBeforeTo = formatDate(lastBefore, false);

      beforeFrom = formatDate(before, true);
      beforeTo = formatDate(before, false);

      currentFrom = formatDate(current, true);
      currentTo = formatDate(current, false);
    }

    else if (groupBy === 'week') {
      const getStartOfWeek = (date) => {
        const d = new Date(date);
        const day = d.getDay();
        const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Monday as start
        return new Date(d.setDate(diff));
      };

      const startOfCurrentWeek = getStartOfWeek(inputFrom);
      const startOfBeforeWeek = new Date(startOfCurrentWeek);
      startOfBeforeWeek.setDate(startOfCurrentWeek.getDate() - 7);
      const startOfLastBeforeWeek = new Date(startOfBeforeWeek);
      startOfLastBeforeWeek.setDate(startOfBeforeWeek.getDate() - 7);

      const makeRange = (start) => {
        const end = new Date(start);
        end.setDate(end.getDate() + 6);
        return [formatDate(start, true), formatDate(end, false)];
      };

      [lastBeforeFrom, lastBeforeTo] = makeRange(startOfLastBeforeWeek);
      [beforeFrom, beforeTo] = makeRange(startOfBeforeWeek);
      [currentFrom, currentTo] = makeRange(startOfCurrentWeek);
    }

    else if (groupBy === 'month') {
      const getMonthRange = (date) => {
        const start = new Date(date.getFullYear(), date.getMonth(), 1);
        const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return [formatDate(start, true), formatDate(end, false)];
      };

      const currentMonth = new Date(inputFrom);
      const beforeMonth = new Date(currentMonth);
      beforeMonth.setMonth(currentMonth.getMonth() - 1);
      const lastBeforeMonth = new Date(currentMonth);
      lastBeforeMonth.setMonth(currentMonth.getMonth() - 2);

      [lastBeforeFrom, lastBeforeTo] = getMonthRange(lastBeforeMonth);
      [beforeFrom, beforeTo] = getMonthRange(beforeMonth);
      [currentFrom, currentTo] = getMonthRange(currentMonth);
    }

    else if (groupBy === 'year') {
      const getYearRange = (year) => [
        `${year}-01-01T00:00:00`,
        `${year}-12-31T23:59:59`
      ];

      const year = inputFrom.getFullYear();
      [lastBeforeFrom, lastBeforeTo] = getYearRange(year - 2);
      [beforeFrom, beforeTo] = getYearRange(year - 1);
      [currentFrom, currentTo] = getYearRange(year);
    }

    return [
      { fromDate: lastBeforeFrom, toDate: lastBeforeTo, groupBy }, // last before
      { fromDate: beforeFrom, toDate: beforeTo, groupBy },         // before
      { fromDate: currentFrom, toDate: currentTo, groupBy }        // current
    ];
  };




  // const getPastCurrentFuturePayloads = ({ fromDate, toDate, groupBy }) => {
  //   const inputFrom = new Date(fromDate);
  //   const inputTo = new Date(toDate);

  //   const formatDate = (date, isStart = true) => {
  //     const d = new Date(date);
  //     d.setHours(isStart ? 0 : 23, isStart ? 0 : 59, isStart ? 0 : 59, 0);
  //     return d.toISOString().split(".")[0]; // Trim milliseconds
  //   };

  //   let pastFrom, pastTo, currentFrom, currentTo, futureFrom, futureTo;
  //   let lastBefore = {}, before = {}, current = {};
  //   if (groupBy === 'day') {
  //     const current = new Date(inputFrom);
  //     const past = new Date(current);
  //     past.setDate(current.getDate() - 1);

  //     const future = new Date(current);
  //     future.setDate(current.getDate() + 1);

  //     pastFrom = formatDate(past, true);
  //     pastTo = formatDate(past, false);

  //     currentFrom = formatDate(current, true);
  //     currentTo = formatDate(current, false);

  //     futureFrom = formatDate(future, true);
  //     futureTo = formatDate(future, false);
  //   }

  //   // else if (groupBy === 'week') {
  //   //   const pastStart = new Date(inputFrom);

  //   //   pastStart.setDate(pastStart.getDate() - 7);
  //   //   const pastEnd = new Date(inputFrom);
  //   //   pastEnd.setDate(pastEnd.getDate() - 1);
  //   //   // console.log("pastEnd",pastEnd)
  //   //   // console.log("pastStart",pastStart)
  //   //   const futureStart = new Date(inputTo);
  //   //   futureStart.setDate(futureStart.getDate() + 1);
  //   //   const futureEnd = new Date(futureStart);
  //   //   futureEnd.setDate(futureEnd.getDate() + 6);
  //   //   // console.log("futureStart",futureStart)
  //   //   // console.log("futureEnd",futureEnd)
  //   //   pastFrom = formatDate(pastStart, true);
  //   //   pastTo = formatDate(pastEnd, false);

  //   //   // console.log("pastFrom",pastFrom)
  //   //   // console.log("pastTo",pastTo)

  //   //   currentFrom = formatDate(inputFrom, true);
  //   //   currentTo = formatDate(inputTo, false);
  //   //   // console.log("currentFrom",currentFrom)
  //   //   // console.log("currentTo",currentTo)
  //   //   futureFrom = formatDate(futureStart, true);
  //   //   futureTo = formatDate(futureEnd, false);
  //   //   // console.log("futureFrom",futureFrom)
  //   //   // console.log("futureTo",futureTo)
  //   // }
  //   else if (groupBy === 'week') {
  //     const currentStart = new Date(inputFrom); // current week start
  //     const currentEnd = new Date(inputTo);     // current week end

  //     // Last week
  //     const beforeStart = new Date(currentStart);
  //     beforeStart.setDate(beforeStart.getDate() - 7);
  //     const beforeEnd = new Date(beforeStart);
  //     beforeEnd.setDate(beforeEnd.getDate() + 6);

  //     // Before last week
  //     const lastBeforeStart = new Date(beforeStart);
  //     lastBeforeStart.setDate(lastBeforeStart.getDate() - 7);
  //     const lastBeforeEnd = new Date(lastBeforeStart);
  //     lastBeforeEnd.setDate(lastBeforeEnd.getDate() + 6);

  //     // Format all
  //     lastBefore = {
  //       from: formatDate(lastBeforeStart, true),
  //       to: formatDate(lastBeforeEnd, false)
  //     };
  //     before = {
  //       from: formatDate(beforeStart, true),
  //       to: formatDate(beforeEnd, false)
  //     };
  //     current = {
  //       from: formatDate(currentStart, true),
  //       to: formatDate(currentEnd, false)
  //     };

  //     // console.log("lastBefore", lastBefore);
  //     // console.log("before", before);
  //     // console.log("current", current);
  //   }


  //   else if (groupBy === 'month') {
  //     const prevMonth = new Date(inputFrom);
  //     prevMonth.setMonth(prevMonth.getMonth() - 1);
  //     const nextMonth = new Date(inputFrom);
  //     nextMonth.setMonth(nextMonth.getMonth() + 1);

  //     const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
  //     const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59);

  //     pastFrom = formatDate(startOfMonth(prevMonth), true);
  //     pastTo = formatDate(endOfMonth(prevMonth), false);

  //     currentFrom = formatDate(startOfMonth(inputFrom), true);
  //     currentTo = formatDate(endOfMonth(inputFrom), false);

  //     futureFrom = formatDate(startOfMonth(nextMonth), true);
  //     futureTo = formatDate(endOfMonth(nextMonth), false);
  //   }

  //   else if (groupBy === 'year') {
  //     const year = inputFrom.getFullYear();

  //     pastFrom = `${year - 1}-01-01T00:00:00`;
  //     pastTo = `${year - 1}-12-31T23:59:59`;

  //     currentFrom = `${year}-01-01T00:00:00`;
  //     currentTo = `${year}-12-31T23:59:59`;

  //     futureFrom = `${year + 1}-01-01T00:00:00`;
  //     futureTo = `${year + 1}-12-31T23:59:59`;
  //   }

  //   return [
  //     { fromDate: pastFrom, toDate: pastTo, groupBy },
  //     { fromDate: currentFrom, toDate: currentTo, groupBy },
  //     { fromDate: futureFrom, toDate: futureTo, groupBy }
  //   ];
  // };

  // const getPastCurrentFuturePayloads = ({ fromDate, toDate, groupBy }) => {
  //   const inputFrom = new Date(fromDate);
  //   const inputTo = new Date(toDate);

  //       const formatDate = (date, isStart = true) => {
  //     const d = new Date(date);
  //     d.setHours(isStart ? 0 : 23, isStart ? 0 : 59, isStart ? 0 : 59, 0);
  //     return d.toISOString().split(".")[0]; // Trim milliseconds
  //   };
  //   let pastFrom, pastTo, currentFrom, currentTo, futureFrom, futureTo
  //   let lastBefore = {}, before = {}, current = {};
  //   if (groupBy === 'day') {
  //     const currentStart = new Date(inputFrom);
  //     const past = new Date(currentStart);
  //     past.setDate(currentStart.getDate() - 1);

  //     const future = new Date(current);
  //     future.setDate(currentStart.getDate() + 1);

  //     pastFrom = formatDate(past, true);
  //     pastTo = formatDate(past, false);

  //     currentFrom = formatDate(current, true);
  //     currentTo = formatDate(current, false);

  //     futureFrom = formatDate(future, true);
  //     futureTo = formatDate(future, false);
  //     // lastBefore = {
  //     //   from: formatDate(past, true),
  //     //   to: formatDate(past, false)
  //     // };
  //     // before = {
  //     //   from: formatDate(currentStart, true),
  //     //   to: formatDate(currentStart, false)
  //     // };
  //     // current = {
  //     //   from: formatDate(future, true),
  //     //   to: formatDate(future, false)
  //     // };
  //   }

  //   else if (groupBy === 'week') {
  //     const currentStart = new Date(inputFrom);
  //     const currentEnd = new Date(inputTo);

  //     // Before (last week)
  //     const beforeStart = new Date(currentStart);
  //     beforeStart.setDate(beforeStart.getDate() - 7);
  //     const beforeEnd = new Date(beforeStart);
  //     beforeEnd.setDate(beforeEnd.getDate() + 6);

  //     // Last Before (2 weeks before)
  //     const lastBeforeStart = new Date(beforeStart);
  //     lastBeforeStart.setDate(lastBeforeStart.getDate() - 7);
  //     const lastBeforeEnd = new Date(lastBeforeStart);
  //     lastBeforeEnd.setDate(lastBeforeEnd.getDate() + 6);

  //     lastBefore = {
  //       from: formatDate(lastBeforeStart, true),
  //       to: formatDate(lastBeforeEnd, false)
  //     };
  //     before = {
  //       from: formatDate(beforeStart, true),
  //       to: formatDate(beforeEnd, false)
  //     };
  //     current = {
  //       from: formatDate(currentStart, true),
  //       to: formatDate(currentEnd, false)
  //     };
  //   }

  //   else if (groupBy === 'month') {
  //     const currentStart = new Date(inputFrom.getFullYear(), inputFrom.getMonth(), 1);
  //     const currentEnd = new Date(inputFrom.getFullYear(), inputFrom.getMonth() + 1, 0, 23, 59, 59, 999);

  //     const beforeStart = new Date(currentStart);
  //     beforeStart.setMonth(beforeStart.getMonth() - 1);
  //     const beforeEnd = new Date(beforeStart.getFullYear(), beforeStart.getMonth() + 1, 0, 23, 59, 59, 999);

  //     const lastBeforeStart = new Date(beforeStart);
  //     lastBeforeStart.setMonth(lastBeforeStart.getMonth() - 1);
  //     const lastBeforeEnd = new Date(lastBeforeStart.getFullYear(), lastBeforeStart.getMonth() + 1, 0, 23, 59, 59, 999);

  //     lastBefore = {
  //       from: formatDate(lastBeforeStart, true),
  //       to: formatDate(lastBeforeEnd, false)
  //     };
  //     before = {
  //       from: formatDate(beforeStart, true),
  //       to: formatDate(beforeEnd, false)
  //     };
  //     current = {
  //       from: formatDate(currentStart, true),
  //       to: formatDate(currentEnd, false)
  //     };
  //   }

  //   else if (groupBy === 'year') {
  //     const currentYear = inputFrom.getFullYear();

  //     const currentStart = new Date(currentYear, 0, 1);
  //     const currentEnd = new Date(currentYear, 11, 31, 23, 59, 59, 999);

  //     const beforeStart = new Date(currentYear - 1, 0, 1);
  //     const beforeEnd = new Date(currentYear - 1, 11, 31, 23, 59, 59, 999);

  //     const lastBeforeStart = new Date(currentYear - 2, 0, 1);
  //     const lastBeforeEnd = new Date(currentYear - 2, 11, 31, 23, 59, 59, 999);

  //     lastBefore = {
  //       from: formatDate(lastBeforeStart, true),
  //       to: formatDate(lastBeforeEnd, false)
  //     };
  //     before = {
  //       from: formatDate(beforeStart, true),
  //       to: formatDate(beforeEnd, false)
  //     };
  //     current = {
  //       from: formatDate(currentStart, true),
  //       to: formatDate(currentEnd, false)
  //     };
  //   }
  //   if (groupBy === 'day') {
  //     return [
  //       { fromDate: pastFrom, toDate: pastTo, groupBy },
  //       { fromDate: currentFrom, toDate: currentTo, groupBy },
  //       { fromDate: futureFrom, toDate: futureTo, groupBy }
  //     ];
  //   } else {
  //     return [
  //       { fromDate: lastBefore.from, toDate: lastBefore.to, groupBy },
  //       { fromDate: before.from, toDate: before.to, groupBy },
  //       { fromDate: current.from, toDate: current.to, groupBy },
  //     ];
  //   }

  // };




  const getDatePickerProps = () => {
    if (view === "Day") {
      return {
        dateFormat: "dd/MM/yyyy",
      };
    } else if (view === "WEEK") {
      return {
        filterDate: isMonday,
        placeholderText: "Select Monday",
        dateFormat: "dd/MM/yyyy",
      };
    } else if (view === "MONTH") {
      return {
        showMonthYearPicker: true,
        dateFormat: "MMMM yyyy", // ⬅️ Will show "May 2025" instead of "05/2025"
      };
    } else if (view === "YEAR") {
      return {
        showYearPicker: true,
        dateFormat: "yyyy",
      };
    }
  };

  const handleCompare = () => {
    setShow(true)
  }


  const getDateRange = (view, currentDate) => {
    let start = new Date(currentDate);
    let end = new Date(currentDate);

    if (view === 'WEEK') {
      const day = start.getDay(); // 0 (Sun) to 6 (Sat)
      const diff = start.getDate() - day + (day === 0 ? -6 : 1); // Monday as the first day of the week
      start.setDate(diff);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
    } else if (view === 'MONTH') {
      start.setDate(1);
      end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    } else if (view === 'YEAR') {
      start = new Date(start.getFullYear(), 0, 1);
      end = new Date(start.getFullYear(), 11, 31);
    }

    const format = (date, isStart) => {
      const y = date.getFullYear();
      const m = `${date.getMonth() + 1}`.padStart(2, '0');
      const d = `${date.getDate()}`.padStart(2, '0');
      return `${y}-${m}-${d}T${isStart ? '00:00:00' : '23:59:59'}`;
    };

    const startDateStr = format(start, true);
    const endDateStr = format(end, false);

    return {
      fromDate: startDateStr,
      toDate: endDateStr,
      groupBy: view.toLowerCase()
    };
  };
  useEffect(() => {
    if (view && currentDate) {
      const dateRangeData = getDateRange(view, currentDate);
      // // console.log("dateRangssssssssssssssssssssssssssssssssssssssssss", dateRangeData)
      const payload = selectedStoreId
        ? { ...dateRangeData, storeId: selectedStoreId }
        : dateRangeData;
      getStatstics(payload);
      dashboard(payload); // Call API with correct data
      counts(payload);
      // const [past, current, future] = getPastCurrentFuturePayloads(payload);
    }
  }, [view, currentDate, selectedStoreId]); // Add selectedStoreId to dependencies


  // const dateRangeData = getDateRange(view, currentDate);

  useEffect(() => {

    getStore()
  }, [])



  useEffect(() => {
    setRoute("user")
    // GetUserData();
    setActiveMenuId(200000)
    // setActiveMenuObj({
    //     "Client Management": false,
    //     "Contact Management":false,
    //     "Reports": false
    // })
    // setData([])
    userActivity();
  }, []);
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    let presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  // // console.log("chartDatatatattatatatatata", chartData)
  // const shiftDate = (direction) => {
  //   const newDate = new Date(currentDate);

  //   if (view === 'DAY') {
  //     newDate.setDate(newDate.getDate() + direction);
  //   } else if (view === 'WEEK') {
  //     newDate.setDate(newDate.getDate() + direction * 7);
  //   } else if (view === 'MONTH') {
  //     newDate.setMonth(newDate.getMonth() + direction);
  //   } else if (view === 'YEAR') {
  //     newDate.setFullYear(newDate.getFullYear() + direction);
  //   }

  //   setCurrentDate(newDate);
  //   setSelectedType("Total")
  // setChartData([])

  // };
  const shiftDate = (date) => {
    const today = new Date();
    // if (date > today) return; // Block future dates

    const newDate = new Date(date);

    if (view === 'DAY') {
      newDate.setDate(newDate.getDate());
    } else if (view === 'WEEK') {
      newDate.setDate(newDate.getDate());
    } else if (view === 'MONTH') {
      newDate.setMonth(newDate.getMonth());
    } else if (view === 'YEAR') {
      newDate.setFullYear(newDate.getFullYear());
    }

    setCurrentDate(newDate);
    setSelectedType("Total");
    setChartData([]);
    setShowCalendar(false);
  };

  const typeKeyMap = {
    Total: 'totalCount',
    Active: 'activeCount',
    Completed: 'completedCount',
    Canceled: 'cancelledCount',
    Expired: 'expiredCount',
    Future: 'pendingCount',
  };
  const formatDate = (date, isStart = true) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}T${isStart ? '00:00:00' : '23:59:59'}`;
  };
  const getRangeByModeFromDate = (mode, fromDate) => {
    let from = new Date(fromDate);
    let to = new Date(fromDate);

    if (mode === "Day") {
      // same day
      to = new Date(from);
    } else if (mode === "Week") {
      to.setDate(to.getDate() + 6);
    } else if (mode === "Month") {
      from = new Date(from.getFullYear(), from.getMonth(), 1);
      to = new Date(from.getFullYear(), from.getMonth() + 1, 0);
    } else if (mode === "Year") {
      from = new Date(from.getFullYear(), 0, 1);
      to = new Date(from.getFullYear(), 11, 31);
    }

    return {
      fromDate: formatDate(from, true),
      toDate: formatDate(to, false),
      groupBy: mode,
    };
  };

  const getRangeByModeToDate = (mode, toDate) => {
    let from = new Date(toDate);
    let to = new Date(toDate);

    if (mode === "Day") {
      from = new Date(to);
    } else if (mode === "Week") {
      to.setDate(to.getDate() + 6);
    } else if (mode === "Month") {
      from = new Date(to.getFullYear(), to.getMonth(), 1);
      to = new Date(to.getFullYear(), to.getMonth() + 1, 0);
    } else if (mode === "Year") {
      from = new Date(to.getFullYear(), 0, 1);
      to = new Date(to.getFullYear(), 11, 31);
    }

    return {
      fromDate: formatDate(from, true),
      toDate: formatDate(to, false),
      groupBy: mode,
    };
  };



  // This updates range1 and sets it to state
  const updateRange1FromDate = (from) => {
    const r1 = getRangeByModeFromDate(selectedMode, from);
    setRange1({ ...r1, groupBy: selectedMode?.toLowerCase() });
  };

  // This updates range2 and sets it to state
  const updateRange2FromDate = (to) => {
    const r2 = getRangeByModeToDate(selectedMode, to);

    setRange2({ ...r2, groupBy: selectedMode?.toLowerCase() });
  };

  // Handlers called by date pickers
  const handleFromDateChange = (date) => {
    setFromDate(date);
    setSameDateError('');
    if (date) updateRange1FromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    setSameDateError('');
    if (date) updateRange2FromDate(date);
  };

  // Update ranges whenever fromDate or selectedMode changes
  useEffect(() => {
    if (!fromDate) return;
    updateRange1FromDate(fromDate);
  }, [fromDate, selectedMode]);

  // Update ranges whenever toDate or selectedMode changes
  useEffect(() => {
    if (!toDate) return;
    updateRange2FromDate(toDate);
  }, [toDate, selectedMode]);

  const getLabel = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const current = new Date(currentDate);
    current.setHours(0, 0, 0, 0);

    const formatShort = (date) =>
      date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    const formatRange = (start, end) => `${formatShort(start)} ~ ${formatShort(end)}`;

    if (view === 'DAY') {
      const diffDays = Math.floor((current - today) / (1000 * 60 * 60 * 24));
      if (diffDays === 0) return `${current.toDateString()} (Today)`;
      if (diffDays === -1) return `${current.toDateString()} (Yesterday)`;
      if (diffDays === 1) return `${current.toDateString()} (Tomorrow)`;
      return current.toDateString();
    }

    if (view === 'WEEK') {
      const getMonday = (date) => {
        const d = new Date(date);
        const day = d.getDay(); // Sunday=0, Monday=1 ... Saturday=6
        const diff = (day === 0 ? -6 : 1) - day; // If Sunday (0), go back 6 days, else go back to Monday
        d.setDate(d.getDate() + diff);
        d.setHours(0, 0, 0, 0);
        return d;
      };

      const currentWeekStart = getMonday(current);
      const currentWeekEnd = new Date(currentWeekStart);
      currentWeekEnd.setDate(currentWeekStart.getDate() + 6);
      currentWeekEnd.setHours(0, 0, 0, 0);

      const todayWeekStart = getMonday(today);

      const diffWeeks = Math.floor((currentWeekStart - todayWeekStart) / (7 * 24 * 60 * 60 * 1000));

      if (diffWeeks === 0) return 'Current Week';
      if (diffWeeks === -1) return 'Last Week';
      if (diffWeeks === 1) return 'Next Week';

      return formatRange(currentWeekStart, currentWeekEnd);
    }


    if (view === 'MONTH') {
      const diffMonths =
        (current.getFullYear() - today.getFullYear()) * 12 + (current.getMonth() - today.getMonth());

      const start = new Date(current.getFullYear(), current.getMonth(), 1);
      const end = new Date(current.getFullYear(), current.getMonth() + 1, 0);

      if (diffMonths === 0) return 'Current Month';
      if (diffMonths === -1) return 'Last Month';
      if (diffMonths === 1) return 'Next Month';

      return formatRange(start, end);
    }

    if (view === 'YEAR') {
      const year = current.getFullYear();
      const currentYear = today.getFullYear();

      const start = new Date(year, 0, 1);
      const end = new Date(year, 11, 31);

      const diffYears = year - currentYear;

      if (diffYears === 0) return 'Current Year';
      if (diffYears === -1) return 'Last Year';
      if (diffYears === 1) return 'Next Year';

      return formatRange(start, end);
    }

    return '';
  };


  const handleViewChange = (selectedView) => {
    setView(selectedView);
    setCurrentDate(new Date());
    setChartData([])
    setSelectedType("Total")
    // You can add other logic here if needed in the future
  };
  const counts = async (data) => {
    // setIsLoading(true)
    try {
      const response = await tmdbApi.getCounts(
        data
      );

      // // console.log(response);
      // setChartData(response?.result?.result)
      setSummary(response?.result)
      setCurrentData([])
      setCompareData([])
      // setIsLoading(false)

      // Example conditional navigation (uncomment and customize as needed):
      // if (response?.result === "PENDING APPROVAL") {
      //   setBtnLoader(false);
      //   navigate("/thankyou");
      // } else {
      //   setBtnLoader(false);
      //   navigate("/verifyaccount");
      // }

    } catch (error) {
      console.error("Error in dashboard API call:", error);
      // Optionally, you can also:
      // setBtnLoader(false);
      // show error to user
    }
  };
  const dashboard = async (data) => {
    setIsLoading(true)
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await tmdbApi.dashboard(
        { ...data, timeZone: timeZone }
      );
      if (response?.result === "Invalid token or Expired") {
        setShowSessionPopupup(true)
      } else {
        // console.log("response", response?.result?.result);

        setChartData(response?.result?.result)
        // setSummary(response?.result?.summary)
        setCurrentData([])
        setCompareData([])
        setIsLoading(false)
      }


      // Example conditional navigation (uncomment and customize as needed):
      // if (response?.result === "PENDING APPROVAL") {
      //   setBtnLoader(false);
      //   navigate("/thankyou");
      // } else {
      //   setBtnLoader(false);
      //   navigate("/verifyaccount");
      // }

    } catch (error) {
      console.error("Error in dashboard API call:", error);
      // Optionally, you can also:
      // setBtnLoader(false);
      // show error to user
    }
  };


  const getStore = (e) => {
    // GetTimeActivity()
    const token = localStorage.getItem("token")
    // const userdata = localStorage.getItem("userdata")
    // // console.log('userdata--->',userdata.username)
    // let userToken = userdata && userdata.token
    // // console.log('userToken--->',userToken)
    axios({
      method: 'POST',
      url: `${lambda}/getStores?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
      // + "&token=" + token,
    })
      .then(function (response) {
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          if (response?.data?.result.length > 0) {
            const result = response?.data?.result;
            // let roleCount = userData?.subscription?.features || []
            // const limits = {};
            // roleCount.forEach(item => {
            //     if (item.label && item.label.startsWith("Max")) {
            //         const key = normalize(item.label.replace("Max", "").replace("Managers", "Manager").replace("Officers", "Officer"));
            //         limits[key] = item.value;
            //     }
            // });
            // if (limits?.stores) {
            //     setStoresMaxLimitReached(limits.stores <= result.length)
            // }
            setIsLoading(false)
            setLocationData(result)
            //  editUser?.companydetails?.[0].accountmanager
          } else {
            // setInvalidContent(true)
            setIsLoading(false)
            // setLocationData(response?.data?.result)
          }

        }

        // setDisableSaveBtn(false)
      });
  }
  const handleStoreChange = (e) => {
    setSelectedStoreId(e.target.value);

    // // console.log("Selected Store ID:", e.target.value);
  };
  const handleFilterClick = (type) => setSelectedType(type);
  // const handleClickCompare = async () => {
  //   setBtnLoader(true);
  //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //   let payload, payload1;

  //   if (selectedStoreId?.length > 0) {
  //     payload = { ...range1, storeid: selectedStoreId, timeZone: timeZone };
  //     payload1 = { ...range2, storeid: selectedStoreId, timeZone: timeZone };
  //   } else {
  //     payload = { ...range1, timeZone: timeZone };
  //     payload1 = { ...range2, timeZone: timeZone };
  //   }

  //   try {
  //     const response = await tmdbApi.dashboard(payload);
  //     const response1 = await tmdbApi.dashboard(payload1);
  //     const statsticsResp = await tmdbApi.getStatstics(payload);
  //     const statsticsResp1 = await tmdbApi.getStatstics(payload1);
  //     const respCounts = await tmdbApi.getCounts(payload);
  //     const respCounts1 = await tmdbApi.getCounts(payload1);
  //     const allStatsArray = [
  //       { data: statsticsResp?.result },
  //       { data: statsticsResp1?.result },

  //     ];
  //     const allCountsArray = [{ data: respCounts?.result },
  //     { data: respCounts1?.result },]
  //     setStatisticsData(allStatsArray)
  //     setAllCounts(allCountsArray)
  //     setCurrentData(response?.result?.result);
  //     setCompareData(response1?.result?.result);
  //     setShow(false);
  //   } catch (error) {
  //     console.error("Error in dashboard API call:", error);
  //   }

  //   setBtnLoader(false);
  // };

  // const getStatstics = async (data) => {
  //   const [past, current, future] = getPastCurrentFuturePayloads(data);

  //   const addStoreIdIfPresent = (payload) => {
  //     return selectedStoreId?.length > 0 ? { ...payload, storeid: selectedStoreId } : payload;
  //   };

  //   const pastPayload = addStoreIdIfPresent(past);
  //   const currentPayload = addStoreIdIfPresent(current);
  //   const futurePayload = addStoreIdIfPresent(future);

  //   // Print payloads for debugging
  //   // console.log("Past Payload:", pastPayload);
  //   // console.log("Current Payload:", currentPayload);
  //   // console.log("Future Payload:", futurePayload);

  //   try {
  //     const [pastResponse, currentResponse, futureResponse] = await Promise.all([
  //       tmdbApi.getStatstics(pastPayload),
  //       tmdbApi.getStatstics(currentPayload),
  //       tmdbApi.getStatstics(futurePayload),
  //     ]);
  //     const allStatsArray = [
  //       { data: pastResponse?.result },
  //       { data: currentResponse?.result },
  //       { data: futureResponse?.result },
  //     ];
  //     setStatisticsData(allStatsArray)
  //     // console.log("All Stats Array:", allStatsArray);
  //     // Optional: set responses to state
  //     // setPastData(pastResponse?.result?.result);
  //     // setCurrentData(currentResponse?.result?.result);
  //     // setFutureData(futureResponse?.result?.result);

  //     setShow(false);
  //   } catch (error) {
  //     console.error("Error in getStatstics API call:", error);
  //   }
  // };




  const isSamePeriod = () => {
    if (!fromDate || !toDate) return false;
    const f = new Date(fromDate);
    const t = new Date(toDate);
    if (selectedMode === 'Day') {
      return f.getFullYear() === t.getFullYear() &&
        f.getMonth() === t.getMonth() &&
        f.getDate() === t.getDate();
    }
    if (selectedMode === 'Month') {
      return f.getFullYear() === t.getFullYear() &&
        f.getMonth() === t.getMonth();
    }
    if (selectedMode === 'Year') {
      return f.getFullYear() === t.getFullYear();
    }
    // Week: compare start-of-week
    return range1.fromDate === range2.fromDate;
  };

  const handleClickCompare = async () => {
    if (isSamePeriod()) {
      setSameDateError(`Please select two different ${selectedMode.toLowerCase()}s to compare.`);
      return;
    }
    setSameDateError('');
    setBtnLoader(true);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let payload, payload1;

    if (selectedStoreId?.length > 0) {
      payload = { ...range1, storeid: selectedStoreId, timeZone };
      payload1 = { ...range2, storeid: selectedStoreId, timeZone };
    } else {
      payload = { ...range1, timeZone };
      payload1 = { ...range2, timeZone };
    }
    console.log("range1.fromDate", range1.fromDate, range1.toDate)
    console.log("range2.toDate", range2.fromDate, range2.toDate)
    try {
      // 🔹 SAVE FULL PERIODS FOR LABELS (start + end + groupBy) so the headers
      // can show the whole selected period, not just the start day.
      setCurrentRange({ ...range1 });
      setCompareRange({ ...range2 });

      const response = await tmdbApi.dashboard(payload);
      const response1 = await tmdbApi.dashboard(payload1);

      const statsticsResp = await tmdbApi.getStatstics(payload);
      const statsticsResp1 = await tmdbApi.getStatstics(payload1);

      const respCounts = await tmdbApi.getCounts(payload);
      const respCounts1 = await tmdbApi.getCounts(payload1);

      setStatisticsData([
        { data: statsticsResp?.result },
        { data: statsticsResp1?.result },
      ]);
      // console.log("currentFromDate", currentFromDate),
      //   console.log("compareFromDate", compareFromDate),
      console.log("respCounts", respCounts?.result)
      console.log("respCounts1", respCounts1?.result)
      // setAllCounts([
      //   { data: respCounts?.result },
      //   { data: respCounts1?.result },
      // ]);
      setAllCounts([
        // console.log("currentFromDate", currentFromDate),
        // console.log("compareFromDate", compareFromDate),
        //  console.log("respCounts", respCounts?.result),
        // console.log("respCounts1", respCounts1?.result),
        {
          label: `Current (${formatPeriodLabel(range1)})`,
          data: respCounts?.result,
        },
        {
          label: `Compare (${formatPeriodLabel(range2)})`,
          data: respCounts1?.result,
        }
      ]);

      setCurrentData(response?.result?.result);
      setCompareData(response1?.result?.result);
      setShow(false);

    } catch (error) {
      console.error("Error in dashboard API call:", error);
    }

    setBtnLoader(false);
  };

  const getStatstics = async ({ fromDate, toDate, groupBy }) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [past, current, future] = getPastCurrentFuturePayloads({ fromDate, toDate, groupBy });

    const addStoreIdIfPresent = (payload) =>
      selectedStoreId?.length > 0 ? { ...payload, storeid: selectedStoreId, timeZone } : { ...payload, timeZone };

    const pastPayload = addStoreIdIfPresent(past);
    const currentPayload = addStoreIdIfPresent(current);
    const futurePayload = addStoreIdIfPresent(future);

    // console.log("Past Payload:", pastPayload);
    // console.log("Current Payload:", currentPayload);
    // console.log("Future Payload:", futurePayload);

    try {
      const [pastResponse, currentResponse, futureResponse] = await Promise.all([
        tmdbApi.getStatstics(pastPayload),
        tmdbApi.getStatstics(currentPayload),
        tmdbApi.getStatstics(futurePayload),
      ]);

      const allStatsArray = [
        { data: pastResponse?.result },
        { data: currentResponse?.result },
        { data: futureResponse?.result },
      ];

      setStatisticsData(allStatsArray);
      // console.log("All Stats Array:", allStatsArray);
      setShow(false);
    } catch (error) {
      console.error("Error in getStatstics API call:", error);
    }
  };

  const handleCancel = () => {

    const today = new Date();
    setView("DAY")
    setCurrentDate(today);
    const defaultMode = "Day"; // use "day" or "Day" based on your logic
    setSelectedMode(defaultMode);

    // reset date pickers
    setFromDate(today);
    setToDate(today);

    // reset range1 and range2
    const r1 = getRangeByModeFromDate(defaultMode, today);
    const r2 = getRangeByModeToDate(defaultMode, today);

    setRange1({ ...r1, groupBy: defaultMode.toLowerCase() });
    setRange2({ ...r2, groupBy: defaultMode.toLowerCase() });


    // optionally reset current store
    // setCurrentStore(""); or keep currentStore unchanged
  };
  const handleEdit = () => {
    setShow(true)
  }

  // console.log("summary", summary)
  return (
    <>
      {showSessionPopupup && <SessionPopup />}

      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        <div className="main-content user-management Dashboard-page" id="dashboard-page">

          <div className="page-content" id="dashboard-content">
            {isLoading ? <Loader /> :
              <div className="container-fluid" id="dashboard-container">
                <div className="row breadcrumb" id="dashboard-breadcrumb">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <h4 className="mb-2 card-title" id="dashboard-title">DASHBOARD</h4>
                      </div>
                      {currentData?.length > 0 && compareData?.length > 0 && (
                        <button className="stroke-btn-style" onClick={handleCancel} id="dashboard-back-button">
                          ← Back
                        </button>
                      )}
                    </div>
                  </div>
                  <BankConnectBanner />
                  {currentData?.length > 0 && compareData?.length > 0 ? (
                    <div className="col-12 d-flex align-items-center justify-content-center py-3" id="compare-title-banner">
                      <h5 className="fw-semibold mb-0" style={{ color: '#555', textAlign: 'center', width: '100%' }}>
                        Comparing&nbsp;
                        <strong>{formatPeriodLabel(currentRange)}</strong>
                        &nbsp;to&nbsp;
                        <strong>{formatPeriodLabel(compareRange)}</strong>
                      </h5>
                    </div>
                  ) : (
                    <div className="row g-3 admin-dashboard-wrapper Visitor-cards-wrapper" id="dashboard-visitor-cards">
                      <div className="col-md-4" id="visitors-in-store">
                        <div className="card dashboard-box features-box">
                          <div className="card-body">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="feu-txt-18">Visitors in Locations</p>
                                <h4 className="feu-txt-20">{summary?.activeCount}</h4>
                              </div>
                              <div className="flex-shrink-0 align-self-center">
                                <div className="feu-icon-section">
                                  <span className="material-symbols-outlined">storefront</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4" id="forecast-30min">
                        <div className="card dashboard-box features-box">
                          <div className="card-body">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="feu-txt-18">Forecast <span className="feu-txt-10">(Visitors in 30 min)</span></p>
                                <h4 className="feu-txt-20">{summary?.forecastCount}</h4>
                              </div>
                              <div className="flex-shrink-0 align-self-center">
                                <div className="feu-icon-section">
                                  <span className="material-symbols-outlined">directions_walk </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4" id="forecast-today">
                        <div className="card dashboard-box features-box">
                          <div className="card-body">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <p className="feu-txt-18">Forecast <span className="feu-txt-10">(Visitors for Today)</span></p>
                                <h4 className="feu-txt-20">{summary?.forecastTodayCount}</h4>
                              </div>
                              <div className="flex-shrink-0 align-self-center">
                                <div className="feu-icon-section">
                                  <span className="material-symbols-outlined">directions_run</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="p-4 bg-white shadow-lg rounded-lg Dashboard-wrapper" id="dashboard-wrapper">
                  {currentData?.length > 0 && compareData?.length > 0 ? (
                    <div className="d-flex justify-content-end align-items-center mb-3" id="dashboard-center">
                      <button className="fill-btn-style" onClick={handleEdit} id="dashboard-edit-button">Edit</button>
                    </div>
                  ) : (
                    <>
                      <div className="row align-items-center gy-3 mb-4" id="dashboard-filters">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3" id="filter-location">
                          <div className="input-group">
                            <span className="input-group-text">
                              <span className="material-symbols-outlined">store</span>
                            </span>
                            <select className="form-select" onChange={handleStoreChange} value={selectedStoreId} id="filter-store-select">
                              <option value="">All Locations</option>
                              {locationData?.map((item) => (
                                <option key={item.storeid} value={item.storeid}>{item.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-12 col-sm-4 col-md-3 col-lg-2" id="filter-compare-button">
                          <button className="btn compare-btn" onClick={handleCompare} id="compare-btn">
                            <span className="material-symbols-outlined">text_compare</span>
                            Compare
                          </button>
                        </div>

                        <div className="col-12 col-md-5 col-lg-7 text-md-end d-flex flex-wrap justify-content-md-end align-items-center gap-2" id="filter-right-controls">
                          <div className="gap-1 me-2 date-selecting-wrapper" id="date-selector">
                            <span className="px-3 py-2 rounded-lg text-sm fw-semibold" onClick={() => setShowCalendar(!showCalendar)} onKeyDown={keyActivate(() => setShowCalendar(!showCalendar))} id="date-label">
                              {getLabel()}
                            </span>
                            {showCalendar && (
                              <div className="position-absolute bg-white shadow p-2 mt-2 rounded" style={{ zIndex: 10, top: 33 }} id="calendar-popup">
                                <div ref={calendarRef}>
                                  <DatePicker
                                    className="form-control custom-date"
                                    inline
                                    selected={currentDate}
                                    onChange={shiftDate}
                                    {...getDatePickerProps()}
                                    popperProps={{
                                      modifiers: [
                                        {
                                          name: 'preventOverflow',
                                          options: { boundary: 'viewport' },
                                        },
                                      ],
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="btn-group" role="group" id="view-selector">
                            {views.map((viewOption) => (
                              <button
                                key={viewOption}
                                className={`btn btn-style ${view === viewOption ? 'active' : ''}`}
                                onClick={() => handleViewChange(viewOption)}
                                id={`view-${viewOption.toLowerCase()}`}
                              >
                                {viewOption.charAt(0) + viewOption.slice(1).toLowerCase()}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="row g-3 mb-2 card-stat-wrapper" id="dashboard-stats">
                        {["Total", "Active", "Completed", "Canceled", "Expired", "Future"].map((type) => (
                          <div key={type} className="col-12 col-sm">
                            <div className="card stat-card" onClick={() => handleFilterClick(type)} onKeyDown={keyActivate(() => handleFilterClick(type))} style={{ cursor: 'pointer' }} id={`stat-${type.toLowerCase()}`}>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-3">
                                  <div className={`value-color-placeholder ${(type === "Canceled" ? "canceled" : type.toLowerCase())}-color`} style={type === "Future" ? { backgroundColor: "#320bf1ff" } : type === "Canceled" ? { backgroundColor: "#8BD1FF" } : undefined}></div>
                                  <span className="value-txt-Style">{type}</span>
                                </div>
                                <span className="value-txt-Style">{summary[typeKeyMap[type]]}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                    </>
                  )}

                  {/* <div id="stacked-bar-chart">
                    <StackedBarChart filterType={filterType} />
                  </div> */}

                  <div id="stacked-bar-chart">

                    {/* NORMAL MODE */}
                    {!(currentData?.length > 0 && compareData?.length > 0) && (
                      <StackedBarChart data={currentData} />
                    )}

                    {/* COMPARE MODE → TWO SEPARATE NORMAL GRAPHS */}
                    {currentData?.length > 0 && compareData?.length > 0 && (
                      <>
                        <div className="mb-4">
                          <h6 className="fw-semibold">
                            {formatPeriodLabel(currentRange)}
                          </h6>
                          <StackedBarChart data={currentData} />
                        </div>

                        <div className="mb-4">
                          <h6 className="fw-semibold">
                            {formatPeriodLabel(compareRange)}
                          </h6>
                          <StackedBarChart data={compareData} />
                        </div>
                      </>
                    )}

                  </div>




                  {currentData?.length > 0 && compareData?.length > 0 && (
                    <div className="mb-4" id="compare-data-table">
                      <DataTable
                        columns={countColumns}
                        keyField="_id"
                        data={allCounts}
                        direction="auto"
                        highlightOnHover
                        fixedHeaderScrollHeight="300px"
                        responsive
                        persistTableHead
                        className="count-table mt-2"
                      />
                    </div>
                  )}
                </div>

                <div className="p-4 mt-4 bg-white rounded-lg Dashboard-wrapper select-period-wrapper">
                  <div className="row g-3 mb-2 card-stat-wrapper">
                    <h5 className="mb-2 form-title">Statistics for selected period</h5>

                    {statisticsData?.map((stat, index) => {
                      // // console.log("stat",stat)
                      const dateLabel = new Date(stat.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      });

                      const {
                        totalReservedCount = 0,
                        totalCompletedCount = 0,
                        repeatVisitor = 0,
                        walkinPercentage = 0,
                        averageVisitDuration = "00:00",
                        favourites = 0,
                        name
                      } = stat.data;

                      const repeatRate = totalCompletedCount > 0
                        ? Math.round((repeatVisitor / totalCompletedCount) * 100)
                        : 0;

                      return (
                        <div className="col-md-4" key={index}>
                          <div className="card stat-card" style={{ cursor: 'pointer' }}>
                            <span className="value-txt-Style mb-2">{name}</span>

                            <div className="select-period-list rounded-3 mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <span className="material-symbols-outlined icon-bg">calendar_month</span>
                                <span className="feu-txt-18">Total Reserved</span>
                              </div>
                              <div className="text-end d-flex align-items-center gap-2">
                                <div className="value-txt-Style">{totalReservedCount}</div>
                              </div>
                            </div>

                            <div className="select-period-list rounded-3 mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <span className="material-symbols-outlined icon-bg">check_circle</span>
                                <span className="feu-txt-18">Total Completed Reserved</span>
                              </div>
                              <div className="text-end d-flex align-items-center gap-2">
                                <div className="value-txt-Style">{totalCompletedCount}</div>
                              </div>
                            </div>

                            {/* Repeat Visitors */}
                            <div className="select-period-list rounded-3 mb-2">
                              <div className="d-flex align-items-center gap-2 left-list">
                                <span className="material-symbols-outlined icon-bg">repeat</span>
                                <span className="feu-txt-18">Repeat Visitor</span>
                              </div>
                              <div className="text-end d-flex align-items-center gap-2 right-list">
                                {/* <p className="mb-0">{repeatVisitor}</p> */}
                                <div className="progress w-100">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: `${repeatVisitor}` }}
                                    aria-valuenow={repeatVisitor}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  ></div>
                                </div>
                                <div className="value-txt-Style">{repeatVisitor}</div>
                              </div>
                            </div>

                            {/* Walk-Ins */}
                            <div className="select-period-list rounded-3 mb-2">
                              <div className="d-flex align-items-center gap-2 left-list">
                                <span className="material-symbols-outlined icon-bg">directions_walk</span>
                                <span className="feu-txt-18">Walk-Ins</span>
                              </div>
                              <div className="text-end d-flex align-items-center gap-2 right-list">
                                {/* <p className="mb-0">{walkinPercentage}</p> */}
                                <div className="progress w-100">
                                  <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: `${walkinPercentage}` }}
                                    aria-valuenow={walkinPercentage}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                  ></div>
                                </div>
                                <div className="value-txt-Style">{walkinPercentage}</div>
                              </div>
                            </div>


                            <div className="select-period-list rounded-3 mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <span className="material-symbols-outlined icon-bg">schedule</span>
                                <span className="feu-txt-18">Average Visit Duration</span>
                              </div>
                              <div className="text-end d-flex align-items-center gap-2">
                                <div className="value-txt-Style">{averageVisitDuration}</div>
                              </div>
                            </div>

                            <div className="select-period-list rounded-3 mb-2">
                              <div className="d-flex align-items-center gap-2">
                                <span className="material-symbols-outlined icon-bg">favorite</span>
                                <span className="feu-txt-18">Favorites</span>
                              </div>
                              <div className="text-end d-flex align-items-center gap-2">
                                <div className="value-txt-Style">{favourites}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>



              </div>
            }

            <Modal
              show={show}
              onHide={() => { setShow(false); setSameDateError(''); }}
              className="compare-modal"
              dialogAs={CompareDialog}
              id="compare-modal"
            >
              {/* Modal content card */}
              <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
              }}>
                {/* Header */}
                <div style={{
                  backgroundColor: 'var(--highlight)',
                  padding: '14px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: '14px', letterSpacing: '0.5px' }}>COMPARE</span>
                  <button
                    onClick={() => { setShow(false); setSameDateError(''); }}
                    style={{
                      background: 'none', border: 'none', cursor: 'pointer',
                      color: '#fff', fontSize: '18px', lineHeight: 1, padding: '0 2px',
                    }}
                    aria-label="Close"
                  >✕</button>
                </div>

                {/* Body */}
                <div style={{ padding: '20px 24px' }}>
                  {/* Day / Week / Month / Year toggle */}
                  <div style={{
                    display: 'flex',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    border: '1px solid var(--highlight)',
                    marginBottom: '20px',
                  }}>
                    {["Day", "Week", "Month", "Year"].map((mode) => (
                      <button
                        key={mode}
                        onClick={() => { setSelectedMode(mode); setSameDateError(''); }}
                        id={`compare-mode-${mode.toLowerCase()}`}
                        style={{
                          flex: 1,
                          padding: '7px 0',
                          fontSize: '12px',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          border: 'none',
                          borderRight: mode !== 'Year' ? '1px solid var(--highlight)' : 'none',
                          cursor: 'pointer',
                          backgroundColor: selectedMode === mode ? 'var(--highlight)' : '#fff',
                          color: selectedMode === mode ? '#fff' : 'var(--highlight)',
                          transition: 'background 0.15s',
                        }}
                      >
                        {mode}
                      </button>
                    ))}
                  </div>

                  {/* Date pickers — From / To */}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                    <div style={{ flex: 1 }}>
                      <DatePicker
                        className="form-control"
                        style={{ width: '100%', fontSize: '12px' }}
                        selected={fromDate}
                        onChange={handleFromDateChange}
                        {...getPickerProps()}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        popperProps={{ strategy: 'fixed' }}
                        popperPlacement="bottom-start"
                      />
                    </div>
                    <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--highlight)', flexShrink: 0 }}>To</span>
                    <div style={{ flex: 1 }}>
                      <DatePicker
                        className="form-control"
                        style={{ width: '100%', fontSize: '12px' }}
                        selected={toDate}
                        onChange={handleToDateChange}
                        {...getPickerProps()}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        popperProps={{ strategy: 'fixed' }}
                        popperPlacement="bottom-start"
                      />
                    </div>
                  </div>

                  {/* Same-date error */}
                  {sameDateError && (
                    <div style={{ color: '#c62828', fontSize: '12px', textAlign: 'center', marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                      <span className="material-symbols-outlined" style={{ fontSize: '14px' }}>error</span>
                      {sameDateError}
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div style={{ padding: '0 24px 20px', textAlign: 'center' }}>
                  <button
                    onClick={handleClickCompare}
                    disabled={btnLoader}
                    id="compare-submit-btn"
                    style={{
                      backgroundColor: 'var(--highlight)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      padding: '9px 40px',
                      fontSize: '12px',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      cursor: btnLoader ? 'not-allowed' : 'pointer',
                      opacity: btnLoader ? 0.7 : 1,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    {btnLoader && <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" style={{ width: '14px' }} />}
                    COMPARE
                  </button>
                </div>
              </div>
            </Modal>

          <Footer id="footer" />
        </div>
      </div>

    </div >
    </>
  );
};

export default DashBoard;
